import React from 'react';
import { Tag } from 'antd';

const NoApprovalsComponent = () => {
    return (
        <h4>No Recommendations Yet</h4>
    );
};

export default NoApprovalsComponent;